import { useEffect, useState, useRef } from "react";
import { Message } from "semantic-ui-react";
import { ReactTable } from "../common";
import { AddTeams } from "./AddTeams";
import { SafeButton, LoadingWrapper } from "../common";
import { canEditAll, filterDataByTeam, getCSRFToken, fetchWithAuth } from "../auth";
import { Link } from "react-router-dom";


export const fieldToNames = {
  'name': 'Name',
  'members': 'Members'
}


export const Teams = (props) => {
  const [columnInfo, setColumnInfo] = useState([])
  const [teams, setTeams] = useState([])
  const [loaded, setLoaded] = useState(false)
  const selectedRef = useRef({})
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const getTeams = async () => {
    setLoaded(false)
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teams/', {
      headers: { 'X-CSRFToken': getCSRFToken() },
      credentials: 'include'
    })
    const respJson = await resp.json()
    let user_info = filterDataByTeam()
    let unsortedTeams = []
    if (user_info && user_info.filterData){
      let filtered_teams_data = respJson.filter(function (o) {
            return (o.members.includes(user_info.name) );
        });
      unsortedTeams = filtered_teams_data
    }else{
      unsortedTeams = respJson
    }

    unsortedTeams.sort((teamA, teamB) => {
      return teamA['name'].localeCompare(teamB['name'], undefined, {numeric: true, sensitivity: 'base'})
    })
    setTeams(unsortedTeams)

    setLoaded(true)
  }

  function updateSelected(ev) {
    selectedRef.current = { ...selectedRef.current, ...ev }
  }

  async function deleteSelectedTeams() {
    setError('')
    setSuccess('')
    let errored = []
    async function deleteTeamsPost(teamId, teamName) {
      let resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teams/' + teamId + '/',
        {
          method: "DELETE",
          headers: { 'X-CSRFToken': getCSRFToken() },
          credentials: 'include'
        }
      )

      if (resp.status > 399){
        errored.push(teamName)
      }
    }

    for (const teamIndex in selectedRef.current) {
      try {
        const toDelete = selectedRef.current[teamIndex]
        if (toDelete) {
          const teamId = teams[teamIndex].id
          const teamName = teams[teamIndex].name
          await deleteTeamsPost(teamId, teamName)
        }
      } catch {
      } // some deleted team from earlier still in the state
    }
    if (errored.length>0){
      setError("Failed to delete: "+ errored)
    }else{
      setSuccess("Successfully deleted team.")
    }
    selectedRef.current = {}
    getTeams()
  }

  function deleteTeams() {
    deleteSelectedTeams()
  }

  useEffect(() => {
    getTeams()
  }, [])


  useEffect(() => {
    setColumnInfo([
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Team Name",
        accessor: "name",
        Cell: (row) => {
          return <Link to={"/teams/" + row.row.original.id + "/view"}>{row.row.original.name}</Link>
        }
      },
      {
        Header: "Team Type",
        accessor: "teamType.name",
        Cell: (row) => {
          return row.row.original.teamType?.name || '-'
        }
      },
      {
        Header: "Status",
        accessor: "isActive",
        Cell: (row) => {
          return row.row.original.isActive === false
            ? <span style={{ color: 'var(--delete)', fontWeight: 'bold' }}>Inactive</span>
            : <span style={{ color: 'green', fontWeight: 'bold' }}>Active</span>
        }
      }
    ])
  }, [])

  return (
    <div>
      {error !== '' &&
        <Message style={{ width: "fit-content" }} compact negative>{error}</Message>
      }
      {success !== '' &&
        <Message style={{ width: "fit-content" }}  compact positive>{success}</Message>
      }
      <LoadingWrapper loading={!loaded} text="Loading teams">
        <ReactTable
          className="channel-table"
          data={teams}
          columns={columnInfo}
          hiddenColumns={['id']}
          editable={canEditAll()}
          setEdit={updateSelected}
        />

        {
          canEditAll() && <div style={{paddingBottom: "2rem", paddingTop: "1rem"}}>
            <AddTeams refresh={getTeams} />
            <SafeButton style={{backgroundColor: "var(--delete)", color: "white"}} submitAction={deleteTeams} submitText="Delete selected" />
          </div>}
      </LoadingWrapper>
    </div>
  );
}
